import React from 'react'
import { Redirect } from 'react-router-dom'
import { requestAccessToken, setFreeeAccessToken, getCodeFromSearchParam, setFreeeRefreshToken } from '../utils/AuthService'
import axios from 'axios';
import { updateFreeeRefreshToken } from "../utils/ApiClient";
import qs from 'qs';

const CLIENT_ID = process.env.REACT_APP_FREEE_CLIENT_ID
const CLIENT_SECRET = process.env.REACT_APP_FREEE_CLIENT_SECRET
const AWS_API_BASE_URL = process.env.REACT_APP_AWS_API_BASE_URL
const FREEE_REDIRECT_URI = process.env.REACT_APP_FREEE_REDIRECT_URI;
const API_KEY = process.env.REACT_APP_AWS_API_KEY

class AuthFreee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // ログインチェック結果.
      location: props.location,
      isFreeeLoggedIn: false,
      isLoading: true,
      isAdmin: false
    }
  }

  componentDidMount() {
    const code = getCodeFromSearchParam(this.state.location.search);
    // ユーザーがアプリの利用を拒否した時に対応
    if (!code) {
      this.setState({
        isFreeeLoggedIn: false,
        isLoading: false
      });
      return
    }
    const data = {
      grant_type: 'authorization_code',
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      redirect_uri: FREEE_REDIRECT_URI,
      code: `${code}`
    };
    const url = AWS_API_BASE_URL + '/api/auth/token';
    const option = {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'x-api-key': API_KEY
      },
      data: data,
      url,
    };
    axios(option)
      .then((response) => {
        const freeeAccessToken = response.data.access_token;
        const freeeRefreshToken = response.data.refresh_token;
        const error = response.data.error;
        setFreeeAccessToken(freeeAccessToken);
        setFreeeRefreshToken(freeeRefreshToken);
          if (error === 'no-admin' || error === 'other-error') {
            this.setState({
              isFreeeLoggedIn: false,
              isLoading: false,
              isAdmin: false
            });
            return
          }
        this.setState({
          isFreeeLoggedIn: true,
          isLoading: false,
          isAdmin: true
        });
        updateFreeeRefreshToken(freeeAccessToken, freeeRefreshToken);
      }
      ).catch((error) => {
        this.setState({
          isFreeeLoggedIn: false,
          isLoading: false
        })
      })
  }

  render() {
    const { isLoading, isFreeeLoggedIn, isAdmin } = this.state
    if (isLoading) {
      return (
        <div>
          loading....
      </div>
      )
    }
    if (!isAdmin) {
      return (
        <div>
          必要な権限がありません
        </div>
      )
    }
    if (isFreeeLoggedIn) {
      return (
        <div>
          <Redirect to="/googleLogin" />
        </div>
      )
    } else {
      return (
        <div>
          <Redirect to="/login" />
        </div>
      )
    }
  }
}

export default AuthFreee